import { render, staticRenderFns } from "./KakaoLogin.vue?vue&type=template&id=3ff94fe6"
import script from "./KakaoLogin.vue?vue&type=script&lang=js"
export * from "./KakaoLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports